export const inappropriateWords = [
'@55',
'@ssfcker',
'@ssfucker',
'@ssfvcker',
'@sshole',
'0ral seks',
'0ral sex',
'0rg@sm',
'0rgasms',
'3jakulating',
'4r5e',
'4r5ed',
'4r5es',
'4skin',
'5h17',
'5h1t',
'5kank',
'a_s_s',
'abbie',
'abeed',
'aboe',
'anal',
'anal hole',
'anal hore',
'anal pirate',
'analingus',
'analplug',
'analplugs',
'anilingus',
'animal fucker',
'anus',
'anus plug',
'ape shit',
'ape shite',
'apeshit',
'apeshite',
'ar5e',
'ar5ehole',
'arse',
'arse gobbler',
'arse hole',
'arse-bandit',
'arse-bandits',
'arse-fucker',
'arse-fuckers',
'arse-hole',
'arse-shagger',
'arsefuck',
'arsefucker',
'arsehole',
'arseshit',
'arsewipe',
'ashole',
'ass',
'ass bandit',
'ass eating boiolas',
'ass eating nob jokeys',
'ass fecker',
'ass fuck',
'ass fucker',
'ass fucking boiolas',
'ass fucking nob jokeys',
'ass hole',
'ass kisser',
'ass licking',
'ass muncher',
'ass-bandit',
'ass-fucker',
'ass-fuckers',
'ass-hole',
'asses',
'assface',
'assfck',
'assfcker',
'assfk',
'assfkcer',
'assfker',
'assfkr',
'assfook',
'assfuccer',
'assfuck',
'assfuck3r',
'assfucker',
'assfuckers',
'assfuckerz',
'assfukah',
'assfukka',
'assfukker',
'assfukkerz',
'assfvck3r',
'assfvcker',
'asshat',
'asshol3',
'asshole',
'asshole fucker',
'assholes',
'assmunch',
'assmuncher',
'asswhole',
'asswipe',
'axe wound',
'azz',
'azzhole',
'b to the inch',
'b???tch',
'b00bz',
'b0llock',
'b0llocks',
'b1+ch',
'b17ch',
'b1otch',
'b1otchs',
'b1tch',
'b1tch1ng',
'b1tch35',
'b1tch3s',
'b1tchees',
'b1tches',
'b1tchez',
'b1tchin',
'b1tching',
'b1tchs',
'b1tchy',
'baby batter',
'ballbag',
'bangbros',
'bassturd',
'bastard',
'bastardish',
'bastards',
'basterd',
'bastid',
'bastinado',
'basturd',
'bater',
'bates',
'batshit',
'batshite',
'bbc',
'bean queen',
'beaner',
'beaners',
'beat my meat',
'beat off',
'beat the meat',
'beat your meat',
'beeotch',
'bell end',
'bellend',
'bender',
'bewbs',
'beyoch',
'beyotch',
'bi + ch',
'bi+ch',
'biatch',
'biches',
'biotch',
'biotches',
'biotchez',
'bishes',
'bitch',
'bitch3s',
'bitchass',
'bitchasses',
'bitched',
'bitcher',
'bitchers',
'bitches',
'bitchez',
'bitchfuck',
'bitchhole',
'bitchin',
"bitchin'",
'bitching',
'bitchlike',
'bitchness',
'bitchs',
'bitchslap',
'bitchtits',
'bitchy',
'bitchy ass',
'bizzach',
'BJ',
'blacky',
'blow a load',
'blow job',
'blowjob',
'blumpkin boy',
'boll0ck',
'bollock',
'bollockchops',
'bollocks',
'bollocktician',
'bollox',
'bondage',
'boner',
'bonk juice',
'boobs',
'booty',
'breasticles',
'breasts',
'bugger',
'bugger off',
'bull shit',
'bullshi',
'bullshit',
'bullshite',
'bum-bandits',
'bum-driller',
'bumhole',
'bung hole',
'butt fuck',
'butt fucker',
'butt hole',
'butt pirate',
'butt-fucker',
'butt-fuckers',
'butt-fucking-bandit',
'butt-munchers',
'buttermilk',
'buttfuck',
'buttfucker',
'buttfuckers',
'butthole',
'butthole boy',
'bwc',
'c*nt',
'c*ntface',
'c*nts',
'c*nty',
'c00n',
'c00nies',
'c0ck',
'c0ckhead',
'c0cks',
'c0cksuccer',
'c0cksucked',
'c0cksucker',
'c0cksuckers',
'c0x',
'c0xux0r',
'caaak',
'caca',
'cack',
'cagone',
'cajones',
'Camel jockey',
'cameltoe',
'carpet muncher',
'carpetmuncher',
'carpetmunchers',
'carpetmunching',
'cawk',
'cawk muncher',
'cawkmuncher',
'cawks',
'cawksucker',
'ch1nk',
'chesticles',
'china-virus',
'chinavirus',
'chinese-virus',
'chingchong',
'chink',
'chinky',
'choad nectar',
'chocha',
'choke the chicken',
'cholo',
'clitlickers',
'closet fuckhead',
'clusterfuck',
'clusterfucked',
'clusterfucker',
'clusterfucking',
'clusterfucks',
'cobb knobbler',
'cock',
'cock droplets',
'cock head',
'cock jockey',
'cock knocker',
'cock licker',
'cock munch',
'cock rider',
'cock smoker',
'cock snot',
'cock suck',
'cock sucker',
'cock sucking',
'cock sucking boiolas',
'cock sucking nob jokeys',
'cock tease',
'cock-face',
'cock-gobbler',
'cock-head',
'cock-sucker',
'cock-suckers',
'cockboy',
'cockeater',
'cockface',
'cockgobbler',
'cockh3ad',
'cockhead',
'cockheads',
'cockhed',
'cockless',
'cocklicker',
'cockmonger',
'cockmunch',
'cockmuncher',
'cocks',
'cockshit',
'cockskin',
'cocksmoker',
'cocksucc',
'cocksuccas',
'cocksuccer',
'cocksuccers',
'cocksuck',
'cocksuckas',
'cocksucked',
'cocksucker',
'cocksuckers',
'cocksucking',
'cocksucking mothafuckers',
'cocksucks',
'cocksuk',
'cocksuka',
'cocksukka',
'cocsuck',
'cokmuncher',
'coksucka',
'coolie',
'coon',
'coon1es',
'cooni3s',
'coonie',
'coonies',
'coons',
'coot',
'coot coot',
'cooter',
'cooter shooting',
'cooterpuffing',
'cooties',
'cotton picker',
'crazy mofos',
'crazy sob',
'creampie',
'crotch',
'crotch fiddler',
'crotchy',
'crow',
'crows',
'cuksuker',
'cuksukka',
'cum goon',
'cumball',
'cumdumpster',
'cumming',
'cums',
'cumslut',
'cumz',
'cunnilingus',
'cunt',
'cunt ass',
'cunt fart',
'cunt lick',
'cunt licker',
'cunt lips',
'cuntasaurus rex',
'cuntbag',
'cuntbollock',
'cuntelope',
'cuntits',
'cuntless',
'cuntlick',
'cuntlicker',
'cuntlickers',
'cuntness',
'cunts',
'cunty',
'cuntz',
'cuunt',
'cyberfck',
'cyberfcks',
'cyberfuccs',
'cyberfucks',
'cyberfucs',
'cyberfukk',
'cyberfukks',
'cyberfvcks',
'd!ck',
'd!cks',
'd!ld0',
'd!ldo',
'd0ggy style',
'd1ck',
'd1ckhead',
'd1ckheads',
'd1cks',
'd1cksucker',
'd1cksukka',
'd1ckz',
'd1ldo',
'dafuq',
'dago',
'darkass',
'darkfuck',
'darkie',
'darkshit',
'darktard',
'darky',
'dick breath',
'dick face',
'dick fucker',
'dick head',
'dick licker',
'dick milker',
'dick nibbler',
'dick smoker',
'dick sucker',
'dick-face',
'dick-gobbler',
'dick-head',
'dickface',
'dickfucker',
'dickhead',
'dickheads',
'dickjockies',
'dickless',
'dicklicker',
'dickmuncher',
'dicks',
'dickskin',
'dickslapper',
'dicksmoker',
'dicksucker',
'dickvag',
'dickz',
'diddle',
'dikhead',
'diks',
'dild0',
'dipsh1t',
'dipsh1tty',
'dipshat',
'dipshidiot',
'dipshit',
'dipshite',
'dipshits',
'dipshitter',
'dipshitty',
'dipstick',
'dirty sanchez',
'dix',
'dlck',
'dlcks',
'dog fuck',
'dog fucker',
'dog fucking',
'dog shit',
'dog-fucker',
"dog's bollocks",
'doggo style',
'doggy style',
'doggy_style',
'dogie style',
'dogsh1t',
'dogsh1ts',
'dogshit',
'dogshits',
'dogstyle',
'dolt',
'dong',
'doosh',
'dothead',
'double dick',
'double dicking',
'double pen',
'double-dong',
'douche',
'douche bag',
'douche canoe',
'douchebag',
'dumasses',
'dumb bastard',
'dumb fucker',
'dumb@ss',
'dumbarrassed',
'dumbass',
'dumbass fucker',
'dumbass mofoes',
'dumbass mothafuckers',
'dumbass son-of-a-bitch',
'dumbasses',
'dumbfucks',
'dumbshit',
'dump a load',
'dune coon',
'dyke',
'erectoplasm',
'f_u_c_k',
"f'ed",
"f'er",
"f@ck",
'f@cker bunny',
'f@g',
'f@gg0t',
'f@gging',
'f@ggot',
'f@gs',
'f@gshit',
'f@k',
'f0ck',
'f0cked',
'f0cker',
'f0ckers',
'face fuck',
'fack',
'fackuhs',
'fag',
'fag asses',
'fag bag',
'fag hag',
'fag queen',
'fag0t',
'faget',
'fagg0t',
'fagging',
'faggo',
'faggot',
'faggot mofoes',
'faggot mothafuckers',
'faggot nob jokeys',
'faggot nobjockies',
'faggot son-of-a-bitch',
'faggoting',
'faggots',
'faggs',
'faggy',
'fagot',
'fags',
'fagshit',
'fart-fucker',
'fatass',
'fatasses',
'fccuker',
'fck',
'fck you',
'fcka',
'fckahz',
'fcked',
'fckedup',
'fcker',
'fckin',
'fcking',
'Fckk',
'fckked',
'fckking',
'fcks',
'fcktard',
'fckyeah',
'fcuk',
'fcuked',
'fcuker',
'fcukers',
'fcuking',
'fcukker',
'fcuks',
'fcvking',
'feck',
'feck arse',
'fecker',
'feg',
'fellatio aficionado',
'fellator',
'fick',
'finger',
'finger fuck',
'fingerbanged',
'fingerpop',
'fk bunny',
'fkbny',
'fked',
'fker',
'fking',
'fkings',
'fkker',
'flamer',
'flamers',
'focker',
'fook',
'fooker',
'fookuh',
'forked',
'fothermuckers',
'fuc',
'fucc',
'fucca',
'fuccers',
'fuccing',
'fuccs',
'Fuck',
'fuck arse',
'fuck face',
'fuck faces',
'fuck goblin',
'fuck head',
'fuck off',
'fuck up',
'fuck y0u',
'fuck you',
'fuck your',
'fuck your mother',
'fucka',
'fuckahs',
'fuckass',
'fuckasses',
'fuckaz',
'fuckbag',
'fuckboy',
'fucked',
'fucked up',
'fuckem',
'fucker',
'fucker off',
'fuckers',
'fuckface',
'fuckfaces',
'fuckhead',
'fuckheaded',
'fuckheads',
'fuckin',
'fucking',
'fucking A',
'fucking asshole',
'fucking bastard',
'fucking hell',
'fucking me',
'fucking retard',
'fucking shit',
'fuckk',
'fuckless',
'fuckmachine',
'fucknuckle',
'fucks',
'fuckshit',
'fuckshitface',
'fuckshithead',
'fuckstar',
'fuckster',
'fuckstick',
'fucktard',
'fucktards',
'fuckup',
'fuckwad',
'fuckwhore',
'fucs',
'fucx',
'fudgefucker',
'fudgepacker',
'fudgepackers',
'fudgepackershitter',
'fudgepacking fucker',
'fugged',
'fugger',
'fuggerz',
'fuggings',
'fugly',
'fuk',
'fuk1n',
'fuk1ng',
'fukcs',
'fuker',
'fukheads',
'fukin',
'fuking',
'fukk',
'fukka',
'fukked',
'fukker',
'fukkers',
'fukking',
'fukkings',
'fukkuh',
'fuks',
'fuku',
'fukwhore',
'fukwit',
'full of shit',
'funbags',
'fuq',
'futhamucka',
'fux',
'fux0r',
'fvck',
'fvck you',
'fvcka',
'fvckbunny',
'fvcker',
'fvckers',
'fvckin',
'fvcking',
'fvckker bunny',
'fvckwhi',
'fxck',
'fxcked',
'fxcker',
'fxcking',
'g@y b1tch',
'g@ylord',
'g@yshit',
'g0ddamn',
'g0ddamned',
'g0ddamnit',
'gash-stabber',
'gay ass',
'gay bitch',
'gay fuck',
'gay fucker',
'gay shit',
'gay wad',
'gayest',
'gaylord',
'gaylords',
'gayness',
'gaysian',
'gaytard',
'geebag',
'get fucked',
'gin jockey',
'girlieboy',
'girly bits',
'girlyboy',
'go fuck yourself',
'go to hell',
'gobshite',
'god dammit',
'god damn',
'god damn it',
'god damned',
'god damnit',
'god-dam',
'god-damned',
'godamnit',
'godd@amn',
'godd@mnit',
'goddammit',
'goddamn',
'goddamn mothafuckers',
'goddamn son of a bitch',
'goddamn son-of-a-bitch',
'goddamned',
'goddamnit',
'gook',
'gowl',
'greaser',
'groid',
'groper',
'gyp',
'harry palms',
'heeb',
'higg@',
'higg3r',
'higga',
'higger',
'higgers',
'hoar',
'hoe',
'hoe-asses',
'hoebag',
'hoes',
'holy fuck',
'homo',
'homo asses',
'homos',
'hooters',
'horse shit',
"horse's asses",
'horseshit',
'hustler',
'injun',
'j-offs',
'j3rk',
'ja!lbait',
'ja1lbait',
'Jack off',
'jack-off',
'jack-offs',
'jackarse',
'jackass',
'jackasses',
'jackasss',
'jackoff',
'jackoffs',
'jackoffz',
'jagoff',
'jailba!t',
'jailbait',
'jap',
'jerk off',
'jerk-0ff',
'jerk-0ffs',
'jerk-off',
'jerk-offs',
'jerking off',
'jerkoff',
'jerkoff jerking off',
'jerkoffs',
'jerks off',
'jewboy',
'jigaboo',
'jigaboos',
'jigga',
'jiggaboo',
'jiggabooboo',
'jiggaboos',
'jiggabu',
'jiggas',
'jigger',
'jiggerboo',
'jiggerboos',
'jiggs',
'jiggyboo',
'jigro',
'jim crow',
'jizz',
'jizz eater',
'jizz licker',
'jizz-jockey',
'jizzbags',
'jizzed',
'jizzes',
'jizzfucker',
'jizzing',
'jizzsacks',
'jizzstain',
'jizzy',
'k!k3',
'k!ke',
'k..!ke',
'k1k3',
'k1ke',
'kid diddler',
'kiddy touch',
'kike',
'kikes',
'kiss ass',
'kiss my ass',
'kitty puncher',
'kkk',
'klan',
'klitoris',
'kneegrows',
'knickers',
'knob',
'knob eater',
'knob gobbler',
'knob jockey',
'knob-face',
'knob-gobbler',
'knob-head',
'knob3d',
'knob3nd',
'knobd',
'knobe',
'knobead',
'knobeads',
'knobed',
'knobeds',
'knobend',
'knobender',
'knobends',
'knobendy',
'knobendz',
'knober',
'knobes',
'knobgobbler',
'knobhead',
'knobheads',
'knobjockies',
'knobjocky',
'knobjokey',
'knobjokeys',
'ku kluxer',
'kyke',
'l@dyb0i',
'l@dyb0y',
'l@dyboy',
'l3i + ch',
'l3i+ch',
'l3itch',
'l3itches',
'ladboys',
'ladboyz',
'ladiboy',
'lady-boy',
'ladyb0i',
'ladyb0y',
'ladyboy',
'ladyboys',
'ladyboyz',
'lesbo',
'loose woman',
'm@asterbated',
'm@derfaker',
'm@derfuck',
'm@derfuckers',
'm0f0',
'm0f0s',
'm0fo',
'm0foes',
'm0fos',
'm0ng0l0id',
'm0ngoloid',
'm0thafucked',
'm0thafucker',
'm0thafucking',
'm0therfuckeds',
'm0therfucker',
'm0therfucking',
'm0therfvcker',
'man chowder',
'man meat',
'man seed',
'markasses',
'meat curtains',
'meat-sword',
'mecha fag',
'mega fag',
"mf'er",
"mf'ers",
"mf'ing",
"mfckers",
'MFer',
'MFers',
'mfing',
'mfk',
'mfs',
'mfukk',
'mfukker',
'milf',
'mindfuck',
'mof0es',
'mof0s',
'mofcker',
'mofo',
'mofo ass',
'mofoes',
'mofos',
'mofoshit',
'mofuccers',
'mofucckers',
'mofuck',
'mofucker',
'mofuckkas',
'mofuk',
'mofukkas',
'molester',
'mong',
'mongoloid',
'mongrel',
'motha fucka',
'motha fucker',
'motha fuckers',
'mothaf@cked',
'mothafcked',
'mothafcking',
'Mothafucc',
'mothafucced',
'mothafuccer',
'mothafuccing',
'mothafuck',
'mothafucka',
'mothafuckas',
'mothafuckasses',
'mothafuckaz',
'mothafuckazzes',
'mothafucked',
'mothafuckeds',
'mothafucker',
'mothafuckers',
'mothafuckin',
'mothafucking',
'mothafuckings',
'mothafuckins',
'mothafucks',
'mothafuckz',
'mothafvcked',
'mother effer',
'mother fuck',
'mother fuck you',
'mother fucka',
'mother fucker',
'mother fuckers',
'mother fucking',
'mothercker',
'motherf@kka',
'motherfacking',
'motherfcked',
'motherfckin',
'motherfcking',
'motherfcks',
'motherfckshit',
'motherfecka',
'motherfecker',
'motherfk',
'motherfucca',
'motherfuccas',
'motherfuccers',
'motherfuck',
'motherfucked',
'motherfuckeds',
'motherfucker',
'motherfuckers',
'motherfuckin',
'motherfucking',
'motherfuckings',
'motherfuckingshit',
'motherfuckins',
'motherfuckka',
'motherfuckkas',
'motherfuckkers',
'motherfucks',
'motherfukka',
'motherfukker',
'motherfukkings',
'motherfvck',
'motherfvcked',
'motherfvckeds',
'motherfvcker',
'motherfvckers',
'motherfvcking',
'motherfxck',
'motherfxcking',
'mothfck',
'mothter fuck',
'mtherfuker',
'mthrfcker',
'muddafukkas',
'mudderfuk',
'mudderfukker',
'mufdive',
'mufdivin',
'muff',
'muffdiving',
'muffdivings',
'muffindivin',
'muffindiving',
'muhfucking',
'mushroom tip',
'mutha fucka',
'mutha fucker',
'muthafecker',
'muthafeckers',
'muthafucka',
'muthafuckers',
'muthafuckings',
'muthafuckker',
'muthafuckkers',
'muthafukka',
'mutherfucker',
'mutherfuckers',
'n0bhead',
'n0bj0cky',
'n1ckker',
'n1g3r',
'n1g3rz',
'n1gg@',
'n1gg@hs',
'n1gg3r',
'n1gg3rs',
'n1gga',
'n1ggah',
'n1ggahs',
'n1ggas',
'n1ggazes',
'n1gger',
'n1ggers',
'n1gguh',
'n3gro',
'negga',
'neggar',
'negr0',
'negro',
'negroes',
'negroid',
'niccer',
'nicka',
'nickas',
'nicker',
'nickk3r',
'nickker',
'nig',
'nig-nog',
'niga',
'nigah',
'nigasses',
'nigers',
'nigg@',
'nigg@hs',
'nigg@s',
'nigg@z',
'nigg@zzes',
'nigg3r',
'nigg3rs',
'nigg4h',
'nigg4hs',
'nigga',
'nigga lover',
'niggah',
'niggahs',
'niggahz',
'niggas',
'niggass',
'niggaz',
'niggazzes',
'nigger',
'nigger lover',
'niggers',
'niggerz',
'niggir',
'niggress',
'nigguh',
'nigguhs',
'nigguhz',
'niglet',
'nignigs',
'nignog',
'nigra',
'nigre',
'nigs',
'niguh',
'nikk3r',
'nikkas',
'nikker',
'nip',
'nob jockey',
'nob jokeys',
'nobbyhead',
'nobhead',
'nobheads',
'nobj0key',
'nobjockies',
'nobjocky',
'nobjokey',
'nobjokeys',
'nobs',
'nonce',
'nuckas',
'nuggets',
'nut butter',
'nutsack',
'nutsacks',
'nympho',
'nymphomaniac',
'octopussy',
'oven dodger',
'p3n1shead',
'p3nisfcker',
'p3nisfcukers',
'p3nisfvcker',
'p3nisfvckers',
'pack my fudge',
'packerfudgehead',
'packing fudge',
'packing fudgehead',
'packingfudge',
'packingfudgefucker',
'packingfudgefucking',
'packsomefudgefucker',
'paki',
'palm jockey',
'pancake face',
'pecker',
'peckerhead',
'pedo',
'pedobear',
'pedobears',
'pedophl',
'pedos',
'pedoz',
'peen',
'peener',
'penisfcker',
'penisfuccer',
'penisfucker',
'penisfuckers',
'penisfvcker',
'penisfvckers',
'penishead',
'peter',
'peter puffer',
'ph@ggots',
'phaggot',
'phaggots',
'phagot',
'phags',
'phuc',
'phucc',
'phuccer',
'phucchead',
'phuccing',
'phuck',
'phuck3r',
'phucked',
'phucker',
'phuckin',
'phucking',
'phuckings',
'phucks',
'phucup',
'phuk',
'phuked',
'phukeds',
'phukhead',
'phuking',
'phukings',
'phukk',
'phukked',
'phukkeds',
'phukker',
'Phukking',
'phuks',
'phukshit',
'phuku',
'phukup',
'phuq',
'phuqs',
'phvckings',
'pig fucker',
'pigfucker',
'pigfuckers',
'pigfucking',
'pigfukker',
'piggyfuck',
'pigshit',
'pillow biter',
'pillow-biter',
'piss face',
'piss off fuckhead',
'piss shit',
'pissoff',
'pissoffs',
'pole licker',
'pole smoker',
'pole sucker',
'polesmoker',
'porch monkey',
'prick',
'prick-face',
'prick-gobbler',
'prick-head',
'pricks',
'pu$sy',
'pu55y',
'pull the pud',
'punani',
'punk ass mofoes',
'punkasses',
'puss',
'pusses',
'pussie',
'pussies',
'pussless',
'pusslicker',
'pussy',
'pussy cat',
'pussy fucker',
'pussy lick',
'pussy licker',
'pussy licking',
'pussylickers',
'pussys',
'pussywhipped',
'puta',
'puussy',
'puzzies',
'puzzy',
'queerasses',
'queers',
'r3t@rd',
'r3t@rded',
'r3tard',
'raghead',
'ragheads',
'ragtard',
'ramrod',
'rat bastard',
'rat baztad',
'reacharound',
'rectum',
'redskin',
'retard',
'retardo',
'retardotron',
'rice monkey',
'rim job',
's_h_i_',
's_h_i_s',
's-lut',
's.o.b.',
's.o.b.s',
's/h/i/t',
'S&M',
'sack',
'salad tosser',
'sambo',
'sand nigger',
'sausage jockey',
'scamfuck',
'schlong',
'scumfuck',
'scumfucker',
'scumfvck',
'scummy',
'scut',
'sh! +',
'sh!+',
'sh1s',
'sh1t',
'sh1t3',
'sh1td1ck',
'sh1tdick',
'sh1te',
'sh1tfuck',
'sh1th3ad',
'sh1theads',
'sh1ts',
'sh1tsome',
'sh1tt',
'sh1tty',
'sh3mal3',
'sh3male',
'shat',
'she-male',
'sheeeet',
'sheet',
'sheister',
'shemal3',
'shemale',
'shemales',
'shet',
'shi+',
'shi+e',
'shi+y',
'shiat',
'shiddick',
'shiester',
'shiesterfuck',
'shiesterfuckface',
'shiesterfuckhead',
'shiesterfucks',
'shipdit',
'shit',
'shit face',
'shit for brains',
'shit fuck',
'shit fucker',
'shit head',
'shit licker',
'shit stain',
'shit-arse',
'shit-ass',
'shit-bandit',
'shit-fucker',
'shit-stuffers',
'shit3',
'shitass',
'shitasses',
'shitassfucker',
'shitassfuckface',
'shitbag',
'shitbird',
'shitblimp',
'shitblimps',
'shitbrain',
'shitd1ck',
'shitdick',
'shitdicks',
'shitdikk',
'shitdip',
'shite',
'shiteblimps',
'shited',
'shitedick',
'shitefuck',
'shitefulls',
'shitehead',
'shites',
'shitey',
'shitface',
'shitfaced',
'shitfacefuck',
'shitfacefucker',
'shitfck',
'shitfk',
'shitfreak',
'shitfuck',
'shitfucker',
'shitfuckhead',
'shitfuckmotherfucker',
'shitfucks',
'shitfudgefucker',
'shitfvck',
'shithead',
'shitheadfucker',
'shitheadfuckface',
'shitheads',
'shithole',
'shits',
'shitsdick',
'shitsfuck',
'shitsful',
'shittastic',
'shittasticfuck',
'shitte',
'shitted',
'shitter',
'shitterfucker',
'shitti',
'shitties',
'shittiest',
'shitting',
'shittings',
'shitty',
'shitty mofoes',
'shittydick',
'shittydicks',
'shittyfuck',
'shittyfuckface',
'shittyful',
'shlong',
'shmale',
'shtfuk',
'shut the fuck up',
'shylock',
'shytfeisterfuck',
'sissy',
'sixty-nine',
'sk@nks',
'sk@nky',
'sk@nkz',
'skank',
'skanks',
'skanky',
'skankz',
'sl@nteye',
'slag',
'slantard',
'slanteye',
'slanteye b1tch',
'slanteyes',
'slanteyeshit',
'slantfreak',
'slanty',
'slit',
'slut',
'slut hole',
'sluts',
'slutty',
'snatch',
'snatch licker',
'soab',
'son o bitch',
'son of a bitch',
'son-of-a-bitch',
'sonna bitch',
'sonofabitch',
'sonofbitches',
'sons of b1tches',
'sons of bitches',
'sons-of-bitches',
'sonz of bitchez',
'soppy bollucks',
'spanking',
'sperm',
'sphincter',
'spic',
'spicfuck',
'spick',
'spics',
'spicshit',
'spig',
'spik',
'spix',
'spook',
'spooks',
'spunk',
'stfu',
'stump chewer',
'stupid fucker',
'stupid hoe',
'stupidasses',
'suck',
'suck my cock',
'suck my d',
'suck my dick',
'suck off',
'sum of a bitch',
'sumbitch',
'swine',
'swine fucker',
'tacohead',
'tadger',
'taking the piss',
'tallywacker',
'tar-baby',
'tard',
'tard asses',
'tart',
'throat yogurt',
'throater',
'tickle the pickle',
'timber nigger',
'tits',
'tongue fucker',
'tongue fucking',
'tosser',
'tossing salad',
'towelhead',
'towelheads',
'towelshithead',
'tramp',
'Tranny',
'transvestite',
'trashb1tch',
'trashbitch',
'trashbitches',
'trashbitchez',
'trashbtch',
'trasherbitch',
'trasherbitchs',
'trashybitches',
'trouser snake',
'trousersnake',
'turdcutter',
'turdhead',
'tw@t',
'twa+',
'twat',
'twat waffle',
'twatface',
'twats',
'twatt',
'twattish',
'twatzilla',
'twink',
'upskirts',
'useless fucker',
'vag',
'vajayjay',
'vulva',
'w@nker',
'w@nkers',
'w4nk3r',
'w4nker',
'wang',
'wang wrangler',
'wank',
'wank off',
'wank3r',
'wank3rs',
'wankbastard',
'wanked',
'wanker',
'wankers',
'wankies',
'wanking',
'wanks',
'we1back',
'weenie',
'weiner',
'wet back',
'wetback',
'wetbacks',
'wh0r3',
'wh0re',
'whack off',
'what the fuck',
'whoar',
'whoars',
'whor3',
'whore',
'whores',
'wigger',
'willy-whacker',
'window licker',
'wise ass',
'wnker',
'wop',
'wophead',
'zip in the wire',
'zipperhead'];
